import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate';
import authentication from './modules/authentication'
import commons from './modules/commons'
import staffs from './modules/staffs'
import products from './modules/products'
import images from './modules/images'
import staffConfigs from './modules/staffConfigs'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    commons,
    authentication,
    staffs,
    products,
    images,
    staffConfigs,
  },
  state: {},
  mutations: {},
  actions: {},
  strict: false,
  plugins: [createPersistedState({paths:['authentication', 'commons'], storage: window.localStorage})]
});
